import React, { useRef } from "react";

import UpdateDeleteBar from "./UpdateDeleteBar";
import {
  Form,
  useLoaderData,
  useSubmit,
  useActionData,
} from "react-router-dom";
import InputFormField from "./InputFormField";
import SelectFormField from "./SelectFormField";
import { isObject } from "lodash";

function Entity({ formShema, children, title }) {
  const serverResponse = useLoaderData();
  const entity = serverResponse.entity;
  const errors = useActionData();
  const ref = useRef();
  const submit = useSubmit();

  const itemDelete = () => submit(ref.current, { method: "delete" });
  const itemSave = () => {
    submit(ref.current, { method: entity.id ? "put" : "post" });
  };

  const titleText = title ? title(entity) : "";

  return (
    <div className="flex-grow-1 overflow-auto">
      <UpdateDeleteBar onDelete={itemDelete} onSave={itemSave} title={titleText} />

      <div className="container-fluid py-4 px-4">
        {errors && Object.keys(errors).length > 0 && (
          <div className="alert alert-danger mb-3">
            Please fix the following fields: {Object.keys(errors).join(", ")}
          </div>
        )}

        <Form ref={ref} id="user-form">
          <div className="card shadow-sm mb-4">
            <div className="card-body p-4">
              <div className="row g-3">
                {formShema.fields.map((field, i) => (
                  <div key={i} className={`col-md-${field.col ?? 6}`}>
                    {field.type === "input" ? (
                      <InputFormField
                        label={field.name}
                        name={field.propertyName}
                        value={entity[field.propertyName]}
                        error={errors ? errors[field.propertyName] : null}
                      />
                    ) : field.type === "checkbox" ? (
                      <div className="d-flex align-items-end h-100 pb-1">
                        <div className="form-check">
                          <input type="hidden" name={field.propertyName} value="false" />
                          <input
                            type="checkbox"
                            id={`field-${field.propertyName}`}
                            name={field.propertyName}
                            value="true"
                            defaultChecked={!!entity[field.propertyName]}
                            className="form-check-input"
                          />
                          <label className="form-check-label" htmlFor={`field-${field.propertyName}`}>
                            {field.name}
                          </label>
                        </div>
                      </div>
                    ) : field.type === "nativeSelect" ? (
                      <>
                        <label className="form-label fw-medium mb-1">{field.name}</label>
                        <select
                          className="form-select"
                          name={field.propertyName}
                          defaultValue={entity[field.propertyName] ?? ""}
                        >
                          <option value="">—</option>
                          {field.options.map((o) => (
                            <option key={o.name} value={o.name}>{o.name}</option>
                          ))}
                        </select>
                      </>
                    ) : (
                      <SelectFormField
                        label={field.name}
                        name={field.propertyName}
                        value={
                          isObject(entity[field.propertyName])
                            ? entity[field.propertyName]
                            : { name: entity[field.propertyName] }
                        }
                        error={errors ? errors[field.propertyName] : null}
                        options={
                          field.options
                            ? field.options
                            : serverResponse[field.optionsFromServer]
                        }
                        isMulti={field.isMulti}
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {children && (
            <div className="card shadow-sm">
              <div className="card-body p-4">
                {children}
              </div>
            </div>
          )}
        </Form>
      </div>
    </div>
  );
}

export default Entity;
